import { api } from "@/http/api-client"
import type { TUser } from "@/lib/auth"

type TProfilePromise = ReturnType<typeof api.get<TUser>>

let profileCache: { promise: TProfilePromise; expiresAt: number } | null = null

export function clearProfileCache() {
  profileCache = null
}

export function getProfile(): TProfilePromise {
  const now = Date.now()
  const ttlMs = 2 * 60 * 1000 // 2 minutes

  if (!profileCache || profileCache.expiresAt <= now) {
    const promise = api.get<TUser>("/users/profile")
    profileCache = {
      promise,
      expiresAt: now + ttlMs,
    }
  }

  return profileCache.promise
}
